import {useEffect, useEffectEvent, useRef, useState} from 'react';
import type {HttpError} from 'api/http/types';
import type {DataLoadStatus} from '../types';

export const useLazyGetResource = <TData>(
  doLoad: boolean,
  get: () => Promise<TData>,
): DataLoadStatus<TData> => {
  const doLoadRef = useRef(false);
  const [result, setResult] = useState<DataLoadStatus<TData>>({
    status: 'NotLoaded',
  });
  const onSetResult = useEffectEvent(setResult);

  useEffect(() => {
    // Trigger loading first time doLoad is true
    if (doLoad && !doLoadRef.current) {
      doLoadRef.current = true;

      if (result.status === 'NotLoaded') {
        onSetResult(old => ({status: 'Loading', data: old.data}));
        get()
          .then(data => setResult(() => ({status: 'Loaded', data})))
          .catch((error: HttpError) =>
            onSetResult(old => ({
              status: 'Failed',
              error,
              data: old.data,
            })),
          );
      }
    }
  }, [doLoad, get, result.status]);

  return result;
};
